import React, { type FC } from 'react';

import type { LinkedLayer } from '@/api/types/linked-layer';
import { LayerIcon } from '@/common/layer-icon';

export interface FieldCardLinkedLayersProps {
    linkedLayers?: LinkedLayer[];
}

export const FieldCardLinkedLayers: FC<FieldCardLinkedLayersProps> = ({ linkedLayers }) => {
    return (
        <>
            {linkedLayers && linkedLayers.length > 0 && (
                <div className="flex flex-row items-center gap-1 mt-2">
                    <LayerIcon />
                    <p className="flex flex-col text-xs text-green">
                        {linkedLayers.length} Layer{linkedLayers.length > 1 ? 's' : ''}
                    </p>
                </div>
            )}

        </>
    );
};
